export const DAY_MAP = {
  [MACROS.PM2CAT.PM2_WDAY_SUNDAY]: gettext('Sunday'),
  [MACROS.PM2CAT.PM2_WDAY_MONDAY]: gettext('Monday'),
  [MACROS.PM2CAT.PM2_WDAY_TUESDAY]: gettext('Tuesday'),
  [MACROS.PM2CAT.PM2_WDAY_WEDNESDAY]: gettext('Wednesday'),
  [MACROS.PM2CAT.PM2_WDAY_THURSDAY]: gettext('Thursday'),
  [MACROS.PM2CAT.PM2_WDAY_FRIDAY]: gettext('Friday'),
  [MACROS.PM2CAT.PM2_WDAY_SATURDAY]: gettext('Saturday'),
};
